import styled from 'styled-components';

import Button from '../../../../../components/Button';
import { Title } from '../../../../../components/v2/Header';

const Container = styled.div`
  overflow-y: auto;
  padding: 15px 20px;
  height: 100%;
`;

const StyledButton = styled(Button)`
  height: 30px;
  width: unset;
`;

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
`;

const StyledTitle = styled(Title)`
  margin-bottom: 15px;
  font-size: 20px;
`;

const MetadataLine = styled.div`
  background: ${({ theme }) => theme.palette.grey[100]};
  border-radius: 6px;
  padding: 6px 10px;
  margin-top: 5px;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

const SectionContainer = styled.div`
  margin-top: 24px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

const NotesTitleRow = styled(TitleRow)`
  justify-content: space-between;
`;

const AutoSavesIndicator = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

const AutoSavesDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.success?.main || '#16a34a'};
  display: inline-block;
`;

const Description = styled.p`
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.text.secondary};
  margin: 0 0 10px;
`;

export {
  StyledButton,
  ButtonRow,
  Container,
  SectionContainer,
  StyledTitle,
  MetadataLine,
  TitleRow,
  NotesTitleRow,
  AutoSavesIndicator,
  AutoSavesDot,
  Description,
};
